import { useRouter } from "next/navigation";

import { useDirectChats } from "@/store/useDirectChats";
import { chatPageUrl } from "@/urls";

/**
 * Opens the direct chat with a user, creating it when there is none yet, and navigates to it.
 * `openDirectChat` resolves to whether it navigated.
 */
export function useOpenDirectChat() {
  const directChats = useDirectChats();
  const router = useRouter();
  const isOpening = directChats.creatingChatStatus === "creating";

  const openDirectChat = async (userUid: string): Promise<boolean> => {
    if (directChats.creatingChatStatus === "creating") return false;

    const chat = await directChats.openChatWith(userUid);
    if (!chat) return false;

    router.push(chatPageUrl({ chatId: chat.uid }));
    return true;
  };

  return { openDirectChat, isOpening };
}
